<template>
    <v-card fill-height :flat="flat" style="height:100%;width:100%;">
        <v-card-title style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">
            <v-layout row>
                <v-flex d-flex md6 class="title" style="padding-top:5px;padding-bottom:5px;align-items:center;">{{title}}</v-flex>
                <v-flex d-flex md6>
                    <v-select v-model="select" :items="dropDownList" flat style="height:100%; max-width:200px; font-size:18px; padding:0px;">
                    </v-select>
                </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-actions ref="chartContainer" fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
            <highcharts v-if="load" style="height:100%;width:100%;" :options="selectedChart"></highcharts>
        </v-card-actions>
    </v-card>
</template>

<script>

    import {Chart} from 'highcharts-vue'
    import More from 'highcharts/highcharts-more'
    import Highcharts from 'highcharts'
    import Exporting from 'highcharts/modules/exporting'

    Exporting(Highcharts)

    More(Highcharts)

    export default {
        name: "DropDownChart",
        components: {
            highcharts: Chart
        },
        props: {
            active: Boolean,
            title: String,
            flat: Boolean,
            chartOptions: Object,
            dropDownList: Array
        },
        data: function () {
            return {
                selectedChart: {},
                select: '',
                load: false
            }
        },
        methods: {
            onResize(event) {
                this.load = false;

                setTimeout(() => {
                    if (typeof this.selectedChart != 'undefined' && typeof this.selectedChart.chart != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                    }

                    this.load = true;
                });
            }
        },
        created() {
            window.addEventListener('resize', this.onResize, {passive: true});
        },
        mounted() {
            setTimeout(() => {
                this.select = this.dropDownList[0];

                if (typeof this.selectedChart != 'undefined' && typeof this.selectedChart.chart != 'undefined') {
                    this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                }

                this.load = true;
                this.chartOptions.credits = {enabled: false};
            });
        },
        watch: {
            select: function () {
                this.selectedChart = this.chartOptions[this.select];
                this.load = false;

                setTimeout(() => {
                    if (typeof this.selectedChart != 'undefined' && typeof this.selectedChart.chart != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                    }
                    this.load = true;
                });
            },
            active: function () {
                this.load = false;

                setTimeout(() => {
                    if (typeof this.selectedChart != 'undefined' && typeof this.selectedChart.chart != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                    }

                    this.load = true;
                });

            }
        }
    }
</script>

<style scoped>
</style>
